export class LoteDto {
  integracaoId: number;
  label: string;
  quadra: string;
}
